import { HttpErrorResponse, type HttpHandlerFn, type HttpInterceptorFn, type HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { ToastService, ValidatorService } from '@capturum/ui/api';
import { TranslateService } from '@ngx-translate/core';
import { parseValidations } from '@shared/helpers/interceptor.helper';
import { tap } from 'rxjs';

export const httpCodeInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const toastService = inject(ToastService);
  const validatorService = inject(ValidatorService);
  const translateService = inject(TranslateService);

  return next(req).pipe(
    tap({
      next: () => {
        return null;
      },
      error: (error: HttpErrorResponse) => {
        if (error instanceof HttpErrorResponse) {
          switch (error.status) {
            case 400:
            case 403:
            case 422:
              parseValidations(error.error, validatorService, toastService, translateService);
              break;
            default:
              break;
          }
        }
      },
    }),
  );
};
